const tottenham = [
  {
    id: 1,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham 2025",
      "2025 tottenham",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/tottenham/25-26-01/uni0.jpg",
      "/images/europa/tottenham/25-26-01/uni1.jpg",
      "/images/europa/tottenham/25-26-01/uni2.jpg",
      "/images/europa/tottenham/25-26-01/uni3.jpg",
      "/images/europa/tottenham/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs 25/26 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham 2025",
      "2025 tottenham",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/tottenham/25-26-02/uni0.jpg",
      "/images/europa/tottenham/25-26-02/uni1.jpg",
      "/images/europa/tottenham/25-26-02/uni2.jpg",
      "/images/europa/tottenham/25-26-02/uni3.jpg",
      "/images/europa/tottenham/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs 25/26 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham 2025",
      "2025 tottenham",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/tottenham/25-26-03/uni0.jpg",
      "/images/europa/tottenham/25-26-03/uni1.jpg",
      "/images/europa/tottenham/25-26-03/uni2.jpg",
      "/images/europa/tottenham/25-26-03/uni3.jpg",
      "/images/europa/tottenham/25-26-03/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs 25/26 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham 2025",
      "2025 tottenham",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/tottenham/25-26-00-es/uni0.jpg",
      "/images/europa/tottenham/25-26-00-es/uni1.jpg",
      "/images/europa/tottenham/25-26-00-es/uni2.jpg",
      "/images/europa/tottenham/25-26-00-es/uni3.jpg",
      "/images/europa/tottenham/25-26-00-es/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs 24/25 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham 2024",
      "2024 tottenham",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/tottenham/24-25-01/uni0.jpg",
      "/images/europa/tottenham/24-25-01/uni1.jpg",
      "/images/europa/tottenham/24-25-01/uni2.jpg",
    ],
  },
  {
    id: 6,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs 24/25 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham 2024",
      "2024 tottenham",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/tottenham/24-25-02/uni0.jpg",
      "/images/europa/tottenham/24-25-02/uni1.jpg",
      "/images/europa/tottenham/24-25-02/uni2.jpg",
    ],
  },
  {
    id: 7,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs 22/23 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham 2022",
      "2022 tottenham",
      "2022",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/tottenham/22-23-01/uni0.jpeg",
      "/images/europa/tottenham/22-23-01/uni1.jpeg",
      "/images/europa/tottenham/22-23-01/uni2.jpeg",
      "/images/europa/tottenham/22-23-01/uni3.jpeg",
      "/images/europa/tottenham/22-23-01/uni4.jpeg",
    ],
  },
  {
    id: 8,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs 21/22 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham 2021",
      "2021 tottenham",
      "2021",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/tottenham/21-22-03/uni0.jpg",
      "/images/europa/tottenham/21-22-03/uni1.jpg",
      "/images/europa/tottenham/21-22-03/uni2.jpg",
      "/images/europa/tottenham/21-22-03/uni3.jpg",
      "/images/europa/tottenham/21-22-03/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs 19/20 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham 2019",
      "2019 tottenham",
      "2019",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/tottenham/19-20-01/uni0.jpg",
      "/images/europa/tottenham/19-20-01/uni1.jpg",
      "/images/europa/tottenham/19-20-01/uni2.jpg",
      "/images/europa/tottenham/19-20-01/uni3.jpg",
      "/images/europa/tottenham/19-20-01/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs 19/20 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham 2019",
      "2019 tottenham",
      "2019",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/tottenham/19-20-02/uni0.jpg",
      "/images/europa/tottenham/19-20-02/uni1.jpg",
      "/images/europa/tottenham/19-20-02/uni2.jpg",
      "/images/europa/tottenham/19-20-02/uni3.jpg",
      "/images/europa/tottenham/19-20-02/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs 19/20 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham 2019",
      "2019 tottenham",
      "2019",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/tottenham/19-20-03/uni0.jpg",
      "/images/europa/tottenham/19-20-03/uni1.jpg",
      "/images/europa/tottenham/19-20-03/uni2.jpg",
      "/images/europa/tottenham/19-20-03/uni3.jpg",
      "/images/europa/tottenham/19-20-03/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs 06/07 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham 2006",
      "2006 tottenham",
      "2006",
      "tottenham retro",
      "retro tottenham",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/tottenham/06-07-02-rt/uni0.jpg",
      "/images/europa/tottenham/06-07-02-rt/uni1.jpg",
      "/images/europa/tottenham/06-07-02-rt/uni2.jpg",
      "/images/europa/tottenham/06-07-02-rt/uni3.jpg",
      "/images/europa/tottenham/06-07-02-rt/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs 98/99 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham 1998",
      "1998 tottenham",
      "1998",
      "tottenham retro",
      "retro tottenham",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/tottenham/98-99-02-rt/uni0.jpeg",
      "/images/europa/tottenham/98-99-02-rt/uni1.jpeg",
      "/images/europa/tottenham/98-99-02-rt/uni2.jpeg",
      "/images/europa/tottenham/98-99-02-rt/uni3.jpeg",
      "/images/europa/tottenham/98-99-02-rt/uni4.jpeg",
    ],
  },
  {
    id: 14,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs 94/95 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham 1994",
      "1994 tottenham",
      "1994",
      "tottenham retro",
      "retro tottenham",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/tottenham/94-95-02-rt/uni0.jpg",
      "/images/europa/tottenham/94-95-02-rt/uni1.jpg",
      "/images/europa/tottenham/94-95-02-rt/uni2.jpg",
      "/images/europa/tottenham/94-95-02-rt/uni3.jpg",
      "/images/europa/tottenham/94-95-02-rt/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs 92/93 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham 1992",
      "1992 tottenham",
      "1992",
      "tottenham retro",
      "retro tottenham",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/tottenham/92-93-01-rt/uni0.jpg",
      "/images/europa/tottenham/92-93-01-rt/uni1.jpg",
      "/images/europa/tottenham/92-93-01-rt/uni2.jpg",
      "/images/europa/tottenham/92-93-01-rt/uni3.jpg",
      "/images/europa/tottenham/92-93-01-rt/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs 92/93 - Uniforme Edição Especial Retrô",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham 1992",
      "1992 tottenham",
      "1992",
      "tottenham retro",
      "retro tottenham",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/tottenham/92-93-00-es-rt/uni0.jpeg",
      "/images/europa/tottenham/92-93-00-es-rt/uni1.jpeg",
      "/images/europa/tottenham/92-93-00-es-rt/uni2.jpeg",
      "/images/europa/tottenham/92-93-00-es-rt/uni3.jpeg",
      "/images/europa/tottenham/92-93-00-es-rt/uni4.jpeg",
    ],
  },
  {
    id: 17,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs - Jaqueta",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham jaqueta",
      "jaqueta tottenham",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/tottenham/jb/uni0.jpg",
      "/images/europa/tottenham/jb/uni1.jpg",
      "/images/europa/tottenham/jb/uni2.jpg",
      "/images/europa/tottenham/jb/uni3.jpg",
      "/images/europa/tottenham/jb/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "europa",
    liga: "premier-league",
    time: "tottenham",
    nome: "Tottenham Spurs - Jaqueta",
    tipo: "masculino",
    aliases: [
      "tottenham spurs",
      "tottenham",
      "spurs",
      "tottenham jaqueta",
      "jaqueta tottenham",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/tottenham/jv/uni0.jpg",
      "/images/europa/tottenham/jv/uni1.jpg",
      "/images/europa/tottenham/jv/uni2.jpg",
      "/images/europa/tottenham/jv/uni3.jpg",
      "/images/europa/tottenham/jv/uni4.jpg",
    ],
  },
];

export default tottenham;
